export const secret = { MAP_API_KEY: 'AIzaSyCfpFcdVqJVPAUjz3W0tG4xm-uN3fwPpbE' };
